<template>
    <div class="form-group mb-20 mb-md-0" :class="inputClass">
        <ValidationContainer :input-id="input.id" :name="placeholder.toLowerCase()" :rules="validationRules">
            <Autocomplete
                    :items="items"
                    :value="value"
                    :get-label="label"
                    :component-item='template'
                    :input-attrs="input"
                    @input="updateAirport"
                    @blur="selectOrClean"
                    @change="clearClass">
            </Autocomplete>

            <div v-show="showError && isInvalid" class="position-absolute mt-0 ml-5 invalid-feedback"
                 :class="errorClass">
                Please enter a valid airport
            </div>
        </ValidationContainer>
    </div>
</template>

<script>
    import ValidationContainer from '../../../../components/Shared/ValidationContainer';
    import AirportTemplate from '../../Templates/AirportTemplate';
    import Autocomplete from 'v-autocomplete';
    import 'v-autocomplete/dist/v-autocomplete.css';
    import axios from 'axios';

    export default {
        props: {
            value: {
                default: null,
                type: [String, Object, Number]
            },
            inputId: {
                required: true,
                type: String
            },
            inputClass: {
                default: null,
                type: [String, Object]
            },
            placeholder: {
                default: '',
                type: String,
            },
            selectedAirport: {
                default: null,
                type: Object,
            },
            showError: {
                default: false,
                type: Boolean
            },
            validationRules: {
                default: null,
                type: [String, Object]
            },
            errorClass: {
                default: null,
                type: [String, Object]
            },
            emptyLabel: {
                default: null,
                type: [String, Object]
            }
        },
        components: {
            Autocomplete,
            ValidationContainer
        },
        data() {
            return {
                items: [],
                input: {
                    placeholder: this.placeholder,
                    class: 'form-control trip-search-input airport',
                    id: this.inputId,
                    autocomplete: 'off'
                },
                template: AirportTemplate,
                isInvalid: false
            }
        },
        methods: {
            label(item) {
                if (item) {
                    return item.name;
                } else {
                    this.items = [];
                    return this.emptyLabel;
                }
            },
            updateAirport(value) {
                this.$emit('input', value);
                this.updateClass(value)
            },
            updateClass(value) {
                if (value) {
                    this.input.class = 'form-control is-valid';
                    this.isInvalid = false;
                } else if (this.isInvalid) {
                    this.input.class = 'form-control is-invalid';
                } else {
                    this.input.class = 'form-control';
                }
            },
            selectOrClean(text) {
                setTimeout(() => {
                    if (!this.value && text) {
                        if (this.items.length > 0) {
                            this.$emit('input', this.items[0])
                        } else {
                            this.isInvalid = true;
                        }
                    }
                }, 200);
            },
            clearClass(text) {
                const savedQuery = document.getElementById(this.inputId).value;
                setTimeout(() => {
                    const newQuery = document.getElementById(this.inputId).value;
                    if (newQuery === savedQuery && newQuery.length > 0) {
                        this.updateAirports(newQuery);
                    }
                }, 400);

                if (text === null || text === '' || text === undefined) {
                    this.isInvalid = false;
                    this.input.class = 'form-control';
                    this.items = [];
                }
            },
            updateAirports(text) {
                if (text) {
                    axios.get('/api/airports/search?filter[search]=' + text)
                        .then((res) => {
                            // Validate that the input value is the same value of the request 
                            if (document.getElementById(this.inputId).value == text ) {
                                this.items = res.data.data.airports;
                                // Don't show already selected airport
                                if (this.selectedAirport) {
                                    this.items = this.items.filter(airport => airport.id !== this.selectedAirport.id);
                                }

                                if (this.items.length === 0) {
                                    this.isInvalid = true;
                                    this.input.class = 'form-control is-invalid';
                                }
                            }
                        });
                }
            },
            getCopy() {
                return {
                    airport: this.value,
                    items: this.items,
                    isInvalid: this.isInvalid
                }
            },
            setValue(copy) {
                this.items = copy.items;
                this.isInvalid = copy.isInvalid;
            },
            clear() {
                this.clearClass('');
                this.items = []
            }
        }
    }
</script>
